import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedVerifiedUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.6712 30.7761L32.8535 19.5938L30.0332 16.7734L21.6712 25.1354L17.515 20.9792L14.6947 23.7995L21.6712 30.7761ZM23.7493 43.5417C19.1643 42.3872 15.3791 39.7565 12.3939 35.6498C9.40864 31.543 7.91602 26.9827 7.91602 21.9688V9.89584L23.7493 3.95834L39.5827 9.89584V21.9688C39.5827 26.9827 38.0901 31.543 35.1048 35.6498C32.1196 39.7565 28.3344 42.3872 23.7493 43.5417Z",
		fill: "url(#paint0_linear_28549_2175)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_28549_2175",
		x1: 7.74939,
		y1: 44.0625,
		x2: 49.5669,
		y2: 22.3174,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedVerifiedUser;
